module.exports = __webpack_public_path__ + "static/crime-cb50b8ddc83067f11c7ca5708c012f03.jpg";